"use client";

import { c as _c } from "react/compiler-runtime";
import { Avatar, Link } from "@heroui/react";
import { buttonVariants, cn } from "@heroui/styles";
import Image from "next/image";
import NextLink from "next/link";
import { useMemo } from "react";
import { useCurrentLocale, useScopedI18n } from "@/lib/i18n";
import { PROJECTS } from "@/lib/projects";
export function Projects(t0) {
  const $ = _c(13);
  const {
    className
  } = t0;
  const t = useScopedI18n("landing.projects");
  const currentLocale = useCurrentLocale();
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currentLocale) {
    t2 = PROJECTS.map(project => {
      const description = project.description[currentLocale as keyof typeof project.description];
      return <NextLink className={cn(buttonVariants({
        variant: "ghost",
        fullWidth: true
      }), "group flex h-fit items-center justify-start gap-4 text-wrap p-4 text-left")} href={project.repo} target="_blank" key={project.name}>{project.image ? <Image className="size-14 rounded-large border" src={project.image} alt={project.name} width={100} height={100} draggable={false} /> : <Avatar className="size-14 rounded-large border"><Avatar.Fallback>{project.name[0].toUpperCase()}</Avatar.Fallback></Avatar>}<div><p className="font-medium text-base">{project.name}</p><p className="line-clamp-1 text-muted text-sm" title={description}>{description}</p></div></NextLink>;
    });
    $[2] = currentLocale;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("more");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link.Icon />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <Link className="mt-1 ml-4" href="https://github.com/itsbrunodev?tab=repositories&q=&type=&language=&sort=stargazers" target="_blank">{t3}{t4}</Link>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t5) {
    t6 = <div className={t1}>{t2}{t5}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}